"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get HrisConnectCallbackResponse () {
        return HrisConnectCallbackResponse;
    },
    get HrisOAuthCallbackResponse () {
        return HrisOAuthCallbackResponse;
    },
    get HrisSignInCallbackResponse () {
        return HrisSignInCallbackResponse;
    },
    get InitiateHrisOAuthFlowResponse () {
        return InitiateHrisOAuthFlowResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const InitiateHrisOAuthFlowResponse = _zod.z.object({
    /** Absolute provider URL the browser is sent to; state is already embedded. */ authorizeUrl: _zod.z.string()
});
const HrisConnectCallbackResponse = _zod.z.object({
    outcome: _zod.z.enum(_models.HRIS_CONNECT_OUTCOMES),
    companyId: _zod.z.string(),
    integrationId: _zod.z.string().optional()
});
const HrisSignInCallbackResponse = _zod.z.object({
    outcome: _zod.z.enum(_models.HRIS_SIGN_IN_OUTCOMES),
    companyId: _zod.z.string(),
    /** Who the web server mints a session for, or denies. Never absent on a sign-in outcome. */ userId: _zod.z.string(),
    email: _zod.z.string(),
    integrationId: _zod.z.string().optional()
});
const HrisOAuthCallbackResponse = _zod.z.discriminatedUnion("outcome", [
    HrisConnectCallbackResponse,
    HrisSignInCallbackResponse
]);
